import script from "./BrandMonitoringDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandMonitoringDashboard.vue?vue&type=script&setup=true&lang=js"

import "./BrandMonitoringDashboard.vue?vue&type=style&index=0&id=59c01984&lang=css"

const __exports__ = script;

export default __exports__